import { render, staticRenderFns } from "./PlaceSelector.vue?vue&type=template&id=f3f5975e&scoped=true&"
import script from "./PlaceSelector.vue?vue&type=script&lang=ts&"
export * from "./PlaceSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PlaceSelector.vue?vue&type=style&index=0&id=f3f5975e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f5975e",
  null
  
)

component.options.__file = "PlaceSelector.vue"
export default component.exports